import { render, staticRenderFns } from "./BoardRow.vue?vue&type=template&id=51ff58e6&scoped=true"
import script from "./BoardRow.vue?vue&type=script&lang=js"
export * from "./BoardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff58e6",
  null
  
)

export default component.exports